import { useContext } from "react";

import {
  DialogConfirmationContext,
  DialogConfirmationContextData,
} from "../contexts/DialogConfirmation";

export function useDialogConfirmation(): DialogConfirmationContextData {
  const context = useContext(DialogConfirmationContext);

  if (!context) {
    throw new Error(
      "useDialogConfirmation must be used within an DrawerProvider"
    );
  }

  return context;
}
